<template>
  <div>
    <gc-order-detail-base
      :show-place-holder="showPlaceHolder"
      :order-detail="orderDetail"
      :express-track="expressTrack"
      :show-product-contract-no="showProductContractNo"
      @goToProgressInfo="handleGoToProgressInfo"
      @goToProductInfo="handleGoToProductInfo"
      @goToExpressInfo="handleGoToExpressInfo"
      @getExpressSheet="handleGetExpressSheet">
      <template #addressOperation="{orderDetail}">
        <slot name="addressOperation" v-bind="{orderDetail}"></slot>
      </template>
      <template #productOperations="{item, orderDetail}">
        <slot name="productOperations" v-bind="{item, orderDetail}"></slot>
      </template>
      <template #orderOperations="{orderDetail}">
        <slot name="orderOperations" v-bind="{orderDetail}"></slot>
        <gc-order-detail-buttons-with-actions
          :order-detail="orderDetail"
        ></gc-order-detail-buttons-with-actions>
      </template>
    </gc-order-detail-base>
  </div>

</template>
<script>
/* eslint-disable */
// 封装了路由跳转, 调用API获取数据
import GcOrderDetailBase from './components/GcOrderDetailBase.vue'
import GcOrderDetailButtonsWithActions from './GcOrderDetailButtonsWithActions.vue'
import { getOrderDetail, getExpressTrack, downloadExpressOutFile } from '@/emktcommon/api/orderApi.js'

export default {
  data () {
    return {
      orderDetail: {},
      expressTrack: {}
    }
  },
  props: {
    showProductContractNo: Boolean,
    showPlaceHolder: Boolean
  },
  watch: {
    // '$route.params.orderNo': {
    //   handler: 'queryOrderDetail',
    //   immediate: true
    // }
  },
  components: { GcOrderDetailBase, GcOrderDetailButtonsWithActions },
  methods: {
    async queryOrderDetail () {
      // this.orderDetail = EMKT.getLocalStorage('currentOrderDetail')

      this.orderDetail = await getOrderDetail(this.$route.params.orderNo)
      console.log('queryOrderDetail', this.orderDetail)
      this.queryExpressTrack ()
    },
    async queryExpressTrack () {
      if (!this.orderDetail) return
      let itemList = []
      let contractNos = []
      itemList = this.orderDetail.itemList
      itemList.forEach(i => {
        contractNos.push(i.contractNo)
      })
      const expressTrackList = await getExpressTrack(contractNos.join(","))
      this.expressTrack = this.processExpressTrack(expressTrackList)
      console.log('expressTrack', expressTrackList, this.expressTrack)
    },
    processExpressTrack (expressList) {
      const expressNoMap = {} // expressNo: list
      expressList.forEach(express => {
        const expressList = expressNoMap[express.mailNo] || []
        expressList.push(express)
        expressNoMap[express.mailNo] = expressList
      })
      const combinedExpressList = []
      Object.keys(expressNoMap).forEach(expressNo => {
        const contractNos = expressNoMap[expressNo].map(express => express.contractNo)
        const combinedExpress = {...expressNoMap[expressNo][0], contractNoList: contractNos}
        combinedExpressList.push(combinedExpress)
      })
      return combinedExpressList
    },
    handleGoToProductInfo (item) {
      console.log('orderItem=================>', item)
      if(item.smartProductGuid) {
        this.$router.push({name: 'WeappGcOrderSmartProductDetail', params: {orderItem: JSON.stringify(item), order: JSON.stringify({fromEmkt: this.orderDetail.fromEmkt})}})
      } else {
        this.$router.push({name: 'WeappGcOrderProductDetail', params: {orderItem: JSON.stringify(item), order: JSON.stringify({fromEmkt: this.orderDetail.fromEmkt})}})
      }
    },
    handleGoToProgressInfo (item) {
      console.log('orderItem=================>', item)
      this.$router.push({ name: 'WeappGcProgress',  params: {orderItem: JSON.stringify(item), orderNo: this.$route.params.orderNo } })
    },
    handleGoToExpressInfo () {
      this.$router.push({ name: 'WeappMyOrderExpress', params: { expressDetail: JSON.stringify(this.expressTrack) } })
    },
    handleGetExpressSheet (item) {
      let contractNo = item.contractNo
      if (contractNo && contractNo !== '') {
        if (item.contractNo.includes(',')) {
          this.$router.push({ name: 'WeappMyOrderExpress', params: { expressDetail: JSON.stringify(this.expressTrack) } })
        } else {
          downloadExpressOutFile(item.contractNo)
        }
      } else {
        alert('无合同编号,无法下载出货单!')
      }
    }
  },
  activated() {
    this.queryOrderDetail()
  }
}
</script>





// WEBPACK FOOTER //
// GcOrderDetailWithActions.vue?33ba417b